/**
 * Mobile / legacy WebView still opens hash routes like /#/about and /#/contact-us.
 * BrowserRouter ignores the hash, so map those to pathname routes before React mounts.
 */
export const ALLOWED_HASH_PUBLIC_PATHS = ['/about', '/contact-us'];

/**
 * @param {string} hash - window.location.hash (e.g. "#/about?x=1")
 * @returns {string|null} pathname + search to navigate to, or null if not a supported public hash path
 */
export function getPathnameFromPublicHash(hash) {
  if (!hash || hash === '#') return null;

  const withoutHash = hash.slice(1);
  const queryIndex = withoutHash.indexOf('?');
  const pathPart =
    queryIndex === -1 ? withoutHash : withoutHash.slice(0, queryIndex);
  const search = queryIndex === -1 ? '' : withoutHash.slice(queryIndex);

  const normalized = (pathPart.replace(/\/$/, '') || '/')
    .replace(/^\/?/, '/')
    .toLowerCase();

  if (!ALLOWED_HASH_PUBLIC_PATHS.includes(normalized)) return null;

  return `${normalized}${search}`;
}

/**
 * Rewrites allowed hash URLs to pathname so BrowserRouter can render the same page.
 * @param {{ hash?: string }} [location]
 * @param {{ replaceState?: Function }} [history]
 * @returns {boolean} true if a rewrite was applied
 */
export function syncHashPublicPathToPathname(
  location = typeof window !== 'undefined' ? window.location : { hash: '' },
  history = typeof window !== 'undefined' ? window.history : { replaceState() {} }
) {
  const nextUrl = getPathnameFromPublicHash(location.hash || '');
  if (!nextUrl) return false;
  history.replaceState(null, '', nextUrl);
  return true;
}
